import React from 'react'
import styles from '../../styles.module.css'


const fmt = (v) => (v === null || v === undefined || v === '') ? '—' : v

const POSITIONS = [
  { key: 'teachers',       label: 'Преподавателей',                    field: 'teachersCount' },
  { key: 'classTeachers',  label: 'Классных руководителей',            field: 'classTeachersCount' },
  { key: 'psychologists',  label: 'Педагогов-психологов',              field: 'pedagoguePsychologistsCount' },
  { key: 'organizers',     label: 'Педагогов-организаторов',           field: 'pedagogueOrganizersCount' },
  { key: 'additionalEdu',  label: 'Педагогов дополнительного образования', field: 'pedagoguesAdditionalEducationCount' },
  { key: 'seniorEdu',      label: 'Старших воспитателей',              field: 'seniorEducatorsCount' },
  { key: 'educators',      label: 'Воспитателей',                      field: 'educatorsCount' },
  { key: 'pe',             label: 'Инструкторов по физической культуре', field: 'physicalCultureInstructorsCount' },
  { key: 'seniorMethod',   label: 'Старших методистов',                field: 'seniorMethodistsCount' },
  { key: 'methodists',     label: 'Методистов',                        field: 'methodistsCount' },
]

const CATEGORIES = [
  { key: 'higher',     label: 'Высшая КК',                           field: 'higherCategoryCount' },
  { key: 'first',      label: 'Первая КК',                           field: 'firstCategoryCount' },
  { key: 'eligibility',label: 'Аттестованы на соответствие занимаемой должности', field: 'positionEligibilityCount' },
]

const EXPERIENCE = [
  { key: 'lt3',  label: 'До 3 лет',     field: 'experienceLessThan3' },
  { key: 'lt10', label: 'До 10 лет',    field: 'experienceLessThan10' },
  { key: 'lt20', label: 'До 20 лет',    field: 'experienceLessThan20' },
  { key: 'gt20', label: 'Более 20 лет', field: 'experienceGreaterThanOrEq20' },
]

const TOTAL_COLS = 3 + POSITIONS.length + CATEGORIES.length + EXPERIENCE.length


const PedagogicalTable = ({ row }) => {
  return (
    <table className={styles.mainTable}>
      <thead>
        <tr className={styles.titleRow}>
          <th className={styles.titleLeft} colSpan={TOTAL_COLS - 1}>Сведения о педагогических работниках</th>
          <th className={styles.titleRight}>Форма №3/СВУ</th>
        </tr>
        <tr className={`${styles.titleRow} ${styles.secondTitleRow}`}>
          <th className={styles.titleLeft} colSpan={TOTAL_COLS - 1}>{row.organizationName}</th>
          <th className={styles.titleRight}>Таблица №2</th>
        </tr>
        <tr>
          <th colSpan={3 + POSITIONS.length}>Количество педагогических работников</th>
          <th colSpan={CATEGORIES.length}>Квалификация</th>
          <th colSpan={EXPERIENCE.length}>Стаж работы</th>
        </tr>
        <tr>
          <th rowSpan={2} className={styles.vertical}>По штату</th>
          <th rowSpan={2} className={styles.vertical}>По списку</th>
          <th rowSpan={2} className={styles.vertical}>Офицеров запаса</th>
          <th colSpan={POSITIONS.length}>из них:</th>
          {CATEGORIES.map(c => <th key={c.key} rowSpan={2} className={styles.vertical}>{c.label}</th>)}
          {EXPERIENCE.map(e => <th key={e.key} rowSpan={2} className={styles.vertical}>{e.label}</th>)}
        </tr>
        <tr>
          {POSITIONS.map(p => <th key={p.key} className={styles.vertical}>{p.label}</th>)}
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{fmt(row.totalPedStaff)}</td>
          <td>{fmt(row.totalPedList)}</td>
          <td>{fmt(row.reserveOfficersPedagogical)}</td>
          {POSITIONS.map(p => <td key={p.key}>{fmt(row[p.field])}</td>)}
          {CATEGORIES.map(c => <td key={c.key}>{fmt(row[c.field])}</td>)}
          {EXPERIENCE.map(e => <td key={e.key}>{fmt(row[e.field])}</td>)}
        </tr>
      </tbody>
    </table>
  )
}

export default PedagogicalTable
